import React from "react";
import { PDFViewer } from "@react-pdf/renderer";
import MyDocumentGroup from "./MyDocumentGroup";

function GroupReport() {
  return (
    <div style={{ width: "1440px" }}>
      <h1>PDF Generator</h1>
      <PDFViewer width="100%" height="600px">
        <MyDocumentGroup />
      </PDFViewer>
    </div>
  );
}

export default GroupReport;
